import { namedStateMapProvider } from "./namedState";

export const feasibilityState = namedStateMapProvider( 'feasibilityConfiguration' );